import { jsx as _jsx } from "react/jsx-runtime";
import SearcherTabs from "../../../../../common/searchers/searcher-tabs/index.js";
import { multisearcherPropsToSearcherTabsProps } from "./converter.js";
export const DesktopMultisearcher = (props)=>/*#__PURE__*/ _jsx(SearcherTabs, {
        ...multisearcherPropsToSearcherTabsProps(props)
    });
export default DesktopMultisearcher;

//# sourceMappingURL=index.js.map